'use client';

import { c as _c } from "react/compiler-runtime";
import { Trash2 } from 'lucide-react';
interface CardDeleteButtonProps {
  visible: boolean;
  label: string;
  onClick: () => void;
}

// Trash control shared by the clothing and outfit cards. A sibling of the
// card's stretched primary button, so it keeps its own semantics.
export function CardDeleteButton(t0) {
  const $ = _c(5);
  const {
    visible,
    label,
    onClick
  } = t0;
  const t1 = `absolute right-2 bottom-2 z-20 touch-manipulation rounded-full bg-white/70 p-1.5 transition-[opacity,background-color] duration-200 hover:bg-white/90 ${visible ? "opacity-100" : "opacity-0 group-hover:opacity-100"}`;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Trash2 className="size-3 text-zinc-400 transition-colors hover:text-red-500" />;
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] !== label || $[2] !== onClick || $[3] !== t1) {
    t3 = <button type="button" onClick={onClick} className={t1} aria-label={label}>{t2}</button>;
    $[1] = label;
    $[2] = onClick;
    $[3] = t1;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
}